import { combineReducers } from "redux";
import authReducer from "./auth";
import errorReducer from "./error";
import locationsReducer from "./locations";

export default combineReducers({
	auth: authReducer,
	errors: errorReducer,
	locations: locationsReducer
});